import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import Header from './components/Header';
import Hero from './components/Hero';
import TrainingPrograms from './components/TrainingPrograms';
import WhyChooseUs from './components/WhyChooseUs';
import CourseDetails from './components/CourseDetails';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from '../home/components/Footer';

export default function TrainingPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Data Analytics Training | ProtectWize Professional Courses',
    description: 'Master data analytics with ProtectWize\'s comprehensive training programs. Expert-led courses in data visualization, business intelligence, AI analytics, and enterprise security. Certification available.',
    keywords: 'data analytics training, business intelligence courses, data visualization training, AI analytics certification, professional development',
    canonical: `${siteUrl}/training`,
    ogType: 'website',
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'EducationalOrganization',
        name: 'ProtectWize Training',
        url: `${siteUrl}/training`,
        description: 'Professional data analytics and business intelligence training programs',
        provider: {
          '@type': 'Organization',
          name: 'ProtectWize'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Course',
        name: 'Data Analytics Professional Training',
        description: 'Comprehensive training program covering data visualization, business intelligence, AI analytics, and enterprise security',
        provider: {
          '@type': 'Organization',
          name: 'ProtectWize'
        },
        offers: {
          '@type': 'Offer',
          category: 'Professional Development',
          availability: 'https://schema.org/InStock'
        },
        educationalLevel: 'Professional',
        coursePrerequisites: 'Basic understanding of data concepts recommended'
      }
    ]
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-950">
      <Header />
      <Hero />
      <TrainingPrograms />
      <WhyChooseUs />
      <CourseDetails />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}